import React from 'react';
import type { Product } from '../lib/types';
import { TypeTheme, discountPercent } from '../lib/types';

export function grad(colors: string[]): React.CSSProperties {
  return { background: `linear-gradient(135deg, ${colors[0]}, ${colors[1] || colors[0]})` };
}

export function Thumb({ emoji, gradient, size = 64, radius = 14, font }: { emoji: string; gradient: string[]; size?: number; radius?: number; font?: number }) {
  return (
    <div className="thumb" style={{ ...grad(gradient), width: size, height: size, borderRadius: radius, fontSize: font ?? size * 0.42 }}>
      {emoji}
    </div>
  );
}

export function Badge({ label, color, icon }: { label: string; color: string; icon?: string }) {
  return (
    <span className="badge tc-badge" style={{ ['--c' as string]: color } as React.CSSProperties}>
      {icon} {label}
    </span>
  );
}

export function Price({ price, mrp }: { price: number; mrp?: number }) {
  if (price === 0) return <span className="free">FREE</span>;
  return (
    <span>
      <span className="price">₹{price}</span>
      {mrp && mrp > price ? <span className="mrp">₹{mrp}</span> : null}
    </span>
  );
}

export function ProductBadges({ product }: { product: Product }) {
  const t = TypeTheme[product.type];
  return (
    <div className="row gap8 wrap">
      <Badge label={t.label} color={t.color} />
      {product.bestseller && <Badge label="Bestseller" color="#FF6B35" icon="🔥" />}
    </div>
  );
}

export function discount(product: Product) {
  return discountPercent(product);
}
